import { IShareDataManager } from './ishare_data_manager';
import { AjaxHelper } from '../../http/ajax_helper';
import { IAjaxHelperConfig } from "../../http/iajax_helper_config";
import { UATranslator } from '../translators/ua_translator';
//import * as $ from 'jquery';
import { ITranslator } from '../translators/itranslator';
import { IDataManagerConfig } from '../data_manager/idata_manager';
import { IClientConfig } from '../data_manager/data_manager_factory';
import { ISharedAlbumsParams, ISharedAlbumPhotosParams } from './ishare_data_manager';
import { IDeleteSharedAlbumParams } from './ishare_data_manager';
import { Util } from '../../common_utils/util';
// import logger from 'logger_module';


/**
 * Responsible to handle all the User Assets flow related share API communications. 
 * @export
 * @class UAShareManager
 * @implements {IShareDataManager}
 */
export class UAShareManager implements IShareDataManager {
    private uaTranslator: ITranslator;
    private discoveryEndPoints: any;
    /**
     *Creates an instance of UAShareManager.
     * @param {IClientConfig} config
     * @memberof UAShareManager
     */
    constructor(config: IClientConfig) {
        this.uaTranslator = Util.getTranslatorObj(config);
        this.discoveryEndPoints = config.discoveryEndPoints;
    }
    /**
     *Method to get albums wich are shared(shared by me/shared with us)     
     * @param {ISharedAlbumsParams} params
     * @returns {*}
     * @memberof UAShareManager
     */
    getSocialAlbumsInfo(params: ISharedAlbumsParams): any {
        // call ajax helper do ajax to get all the albums data
        const url = `social/feed/collection?${Util.prepareParamString(params, [])}`;
        const config = {
            url : this.discoveryEndPoints.pictService + url,
            type: 'GET',
        };

        const promise = AjaxHelper.triggerApi({requestConfig: config}, this.uaTranslator.translateSharedAlbums.bind(this.uaTranslator))       
        return promise;
    }
    /**
     *Method to delete a shared albums     
     * @param {IDeleteSharedAlbumParams} queryParamsObj
     * @returns {*}
     * @memberof UAShareManager
     */
    deleteSocialAlbum(queryParamsObj: IDeleteSharedAlbumParams): any {
        // call ajax helper do ajax to delete the album.        
        const url = "social/reject/collection/" + queryParamsObj.albumId;
        const config = {
            url : this.discoveryEndPoints.pictService + url,
            type: 'DELETE',
        };

        const promise = AjaxHelper.triggerApi({requestConfig: config})        
        return promise;
    }
    /**
     *Method to get info regarding a single shared album.     
     * @param {ISharedAlbumPhotosParams} params
     * @returns {*}
     * @memberof UAShareManager
     */
    getSharedSingleAlbumInfo(params: ISharedAlbumPhotosParams): any {
        // call ajax helper do ajax to get all the albums data
        // https://assets.snapfish.com/pict/v2/social/detail/story/122864815904070/a/13370647023/dc/AUS?assetType=ALL&_=1575576293446
        const url = `social/detail/story/${params.albumId}/a/${params.ownerId}/dc/${params.datacenter}?assetType=${params.assetType}`;
        const config = {
            url : this.discoveryEndPoints.pictService + url,
            type: 'GET',
        };

        const promise = AjaxHelper.triggerApi({requestConfig: config}, this.uaTranslator.translateSharedAlbumPhotos.bind(this.uaTranslator))
        
        return promise;
    }
    /**
     *Method used to return the translator object 
     * @returns
     * @memberof UAShareManager
     */
    getTranslator(){        
        return this.uaTranslator;       
    }
}